// Rozet sayacının saf mantığı (mimari 9.26.7.1, 9.26.7.2.1).
// Bileşenlerden ayrı tutuluyor: tanım test edilebilir kalsın, dört yüzey de
// aynı fonksiyonları çağırsın diye.
import type { Conversation, Meetup } from '../services/api';
import { formatDisplayCount } from '../i18n/formatCount';

// Rozet iki haneyi geçince sayı okunmuyor ve dock ikonunu taşırıyor.
// Sohbet satırındaki rozette bugün kırpma yok; dock için sınır konuldu.
export const BADGE_CAP = 99;

export function formatBadgeCount(count: number, language?: string): string {
  return count > BADGE_CAP ? `${formatDisplayCount(BADGE_CAP, language)}+` : formatDisplayCount(count, language);
}

// Toplam okunmamış (D-055): susturulmuş sohbetler toplamdan düşer — satırdaki
// kendi rozetini göstermeye devam ederler, yalnız toplama girmezler.
// Arşivlenmiş sohbetler zaten bu listede yok (`/conversations` varsayılan olarak
// arşivi hariç tutuyor), engellenenleri de sunucu eliyor.
export function totalUnread(conversations: Conversation[]): number {
  return conversations.reduce((sum, c) => (c.muted ? sum : sum + conversationUnread(c)), 0);
}

// Bir sohbetin sayaca kattığı miktar. Elle "okunmadı" işaretlenmiş ama gerçekte
// okunmamış mesajı olmayan sohbet **1** sayılır (9.26.7.1.2): kullanıcı oraya
// dönmek istediğini söylemiştir, rozet bunu göstermezse işaret işe yaramaz.
export function conversationUnread(c: Conversation): number {
  if (c.unread_count > 0) return c.unread_count;
  return c.manual_unread ? 1 : 0;
}

// Takvim sekmesinin sayacı (D-057): kaynağı mesaj değil, cevap bekleyen
// buluşma teklifleri — 9.3.2.5'in "İstekler" görünümünde en üste aldığı küme.
export function pendingMeetupCount(meetups: Meetup[]): number {
  return meetups.filter((m) => m.status === 'pending' && m.direction === 'received').length;
}
